module.exports = "App.Collections.ContactIMs = Backbone.Collection.extend({\n\n  model: App.Models.ContactIM\n  \n});\n"